import { render } from "./EndScreen.vue?vue&type=template&id=9d7dfd4c&scoped=true"
import script from "./EndScreen.vue?vue&type=script&lang=js"
export * from "./EndScreen.vue?vue&type=script&lang=js"

import "./EndScreen.vue?vue&type=style&index=0&id=9d7dfd4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7dfd4c"]])

export default __exports__